// extracted by mini-css-extract-plugin
export default {"empty-list-icon":"EmptyListIcon_empty-list-icon__u6b+G","empty-list-icon__text":"EmptyListIcon_empty-list-icon__text__q9wtb"};